import { useState } from "react";

import { Card } from "./card";
import { Alternative } from "src/helpers/types";
import { cn } from "src/lib/utils";
import { useContext } from "react";
import { LanguageContext } from "../languageContext";

export default function AlternativesCarouselCard({
  alternatives,
  children,
  map,
}: {
  alternatives: Alternative[];
  children: (alternative: Alternative) => React.ReactNode;
  map: (alternative: Alternative) => React.ReactNode;
}) {
  const [alternative, setAlternative] = useState<Alternative>(alternatives[0]);
  const { translate } = useContext(LanguageContext);

  return (
    <Card className="flex-1 max-w-[540px] mx-[-20px]">
      <div className="flex flex-row bg-primary-100">
        <div className="flex flex-col">
          {alternatives.map((alt, index) => (
            <button
              key={alt}
              className={cn(
                "text-sm whitespace-pre-line p-4 flex-1 text-left text-secondary-foreground",
                index === 0 && "md:rounded-tl-lg",
                alt === alternative
                  ? "bg-primary font-bold"
                  : "bg-secondary hover:bg-gray-700"
              )}
              onClick={() => setAlternative(alt)}
            >
              {translate(`altName-${alt}`).replace(
                /\//g,
                "/\n" // render converging/diverging with a new line at the "/"
              )}
            </button>
          ))}
        </div>
        {map(alternative)}
      </div>
      {children(alternative)}
    </Card>
  );
}
